import { Marker } from 'react-naver-maps';
import MantangLocationIcon from '@/assets/svgs/mantang-location.svg';

type PlaceMarkerProps = {
	lat?: number | null;
	lng?: number | null;
};

const PlaceMarker = ({ lat, lng }: PlaceMarkerProps) => {
	if (!lat || !lng) {
		return null;
	}

	return (
		<Marker
			position={{
				lat: lat,
				lng: lng,
			}}
			icon={MantangLocationIcon}
		/>
	);
};

export default PlaceMarker;
